import type { InjectionKey, Ref } from 'vue'
import type { LocationModel } from '@truckdown/locations';

export const locationKey: InjectionKey<Ref<LocationModel>> = Symbol('location');
export const locationUpdateKey: InjectionKey<(value: LocationModel) => void> =
    Symbol('locationUpdate');